/** Wide enough for title + supplier / code / SKU / rating meta without clipping. */
export const BOM_TYPEAHEAD_MIN_WIDTH_PX = 520

export const BOM_TYPEAHEAD_SUGGESTIONS_CONTAINER_PROPS = {
  placement: 'auto-start',
} as const

const VIEWPORT_EDGE_PADDING_PX = 8
const ANCHOR_GAP_PX = 8
const DEFAULT_MAX_HEIGHT_VH = 0.4

const getAvailableSpaceAboveAnchorPx = (anchorEl: HTMLElement): number => {
  const anchorTop = anchorEl.getBoundingClientRect().top
  return anchorTop - VIEWPORT_EDGE_PADDING_PX - ANCHOR_GAP_PX
}

const getAvailableSpaceBelowAnchorPx = (anchorEl: HTMLElement): number => {
  const anchorBottom = anchorEl.getBoundingClientRect().bottom
  return window.innerHeight - anchorBottom - VIEWPORT_EDGE_PADDING_PX - ANCHOR_GAP_PX
}

export const isPlacementAbove = (placement: string): boolean =>
  typeof placement === 'string' && placement.startsWith('top')

/** Resolve `auto-start` once per open; compares space above vs below (no Popper flip). */
export const resolveAutocompletePlacement = (anchorEl: HTMLElement, requestedPlacement: string): string => {
  if (requestedPlacement === 'auto-start') {
    const spaceAbove = getAvailableSpaceAboveAnchorPx(anchorEl)
    const spaceBelow = getAvailableSpaceBelowAnchorPx(anchorEl)
    return spaceAbove >= spaceBelow ? 'top-start' : 'bottom-start'
  }
  return requestedPlacement
}

/** Cap dropdown height so the list stays on the chosen side without covering the anchor. */
export const getMaxHeightForAnchorPx = (anchorEl: HTMLElement, opensAbove: boolean): number => {
  const available = opensAbove ? getAvailableSpaceAboveAnchorPx(anchorEl) : getAvailableSpaceBelowAnchorPx(anchorEl)
  const cap = window.innerHeight * DEFAULT_MAX_HEIGHT_VH
  return Math.max(0, Math.floor(Math.min(cap, available)))
}
